Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inject = require('aphrodite/lib/inject');

var _resolve2 = require('./utils/resolve');

var _resolve3 = _interopRequireDefault(_resolve2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function (_ref /* aphrodite */) {
  var StyleSheet = _ref.StyleSheet,
      css = _ref.css;
  return {
    create: function () {
      function create(styleHash) {
        return StyleSheet.create(styleHash);
      }

      return create;
    }(),
    resolve: function () {
      function resolve(styles) {
        return (0, _resolve3['default'])(css, styles);
      }

      return resolve;
    }(),
    resolveNoRTL: function () {
      function resolveNoRTL(styles) {
        return (0, _resolve3['default'])(css, styles);
      }

      return resolveNoRTL;
    }(),


    // Flushes all buffered styles to a style tag. Required for components
    // that depend upon previous styles in the component tree (i.e.
    // for calculating container width, including padding/margin).
    flush: function () {
      function flush() {
        (0, _inject.flushToStyleTag)();
      }

      return flush;
    }()
  };
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-with-styles-interface-aphrodite/lib/aphroditeInterfaceFactory.js
// module id = 499
// module chunks = 1